<template>
    <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_14746_6800)">
            <path d="M9.96957 10.3462C11.2791 9.59667 12.1739 8.20102 12.1739 6.58709C12.1739 4.1897 10.2235 2.23926 7.82608 2.23926C5.42869 2.23926 3.47824 4.1897 3.47824 6.58709C3.47824 8.20102 4.37303 9.59667 5.68259 10.3462C2.40697 11.2062 0 13.9758 0 17.2584V18.3262C0 18.5662 0.194796 18.761 0.434796 18.761C0.674796 18.761 0.869592 18.5662 0.869592 18.3262V17.2584C0.869551 13.7723 3.99045 10.9349 7.82608 10.9349C11.6617 10.9349 14.7826 13.7723 14.7826 17.2584V18.3262C14.7826 18.5662 14.9774 18.761 15.2174 18.761C15.4574 18.761 15.6522 18.5662 15.6522 18.3262V17.2584C15.6522 13.9758 13.2452 11.2054 9.96957 10.3462ZM4.34784 6.58709C4.34784 4.66885 5.90784 3.10885 7.82608 3.10885C9.74433 3.10885 11.3043 4.66885 11.3043 6.58709C11.3043 8.50534 9.74433 10.0653 7.82608 10.0653C5.90784 10.0653 4.34784 8.50538 4.34784 6.58709Z" fill="currentColor"/>
            <path d="M15.8246 10.3576C16.7672 9.73415 17.3916 8.66805 17.3916 7.45676C17.3916 5.53851 15.8316 3.97852 13.9133 3.97852C13.6733 3.97852 13.4785 4.17331 13.4785 4.41331C13.4785 4.65331 13.6733 4.84811 13.9133 4.84811C15.3516 4.84811 16.522 6.01855 16.522 7.4568C16.522 8.89505 15.3516 10.0655 13.9133 10.0655C13.6733 10.0655 13.4785 10.2603 13.4785 10.5003C13.4785 10.7403 13.6733 10.935 13.9133 10.935C16.7907 10.935 19.1307 13.0976 19.1307 15.7567V16.5871C19.1307 16.8271 19.3255 17.0219 19.5655 17.0219C19.8055 17.0219 20.0003 16.8271 20.0003 16.5871V15.7567C20.0003 13.2437 18.2472 11.1089 15.8246 10.3576Z" fill="currentColor"/>
        </g>
        <defs>
            <clipPath id="clip0_14746_6800">
                <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
        </defs>
    </svg>

</template>

<script>
export default {
    name: 'ArchiveStatusIconUser',
}
</script>

<style lang="scss" scoped>

</style>
